define('router/router-tasks/router-tasks',['require','exports','module','i18next','api-access','api-access','api-access','moment-timezone','cookie-handler','plugins/dialog','bowser','meetings/lib/plugins-modal/plugins'],function (require, exports, module) {
    var i18n = require('i18next');
    var userApi = require('api-access').user;
    var meetingsApi = require('api-access').meetings;
    var gotomeetApi = require('api-access').gotomeet;
    var moment = require('moment-timezone');
    var cookieHandler = require('cookie-handler');
    var dialog = require('plugins/dialog');
    var bowser = require('bowser');
    var Plugins = require('meetings/lib/plugins-modal/plugins');

    var rememberUser = function () {
        cookieHandler.set(90, 'G2MProminentLogin', 'G2MExistingUser=true');
    };

    /**
     * returns a promise that resolves with a greeting: "Hello, Jane"
     */
    var greeting = function () {
        return userApi.me().then(function (me) {
            return i18n.t('greeting') + me.firstName;
        });
    };

    var pluginModal = function () {
        var gotomeetMeetingId;

        gotomeetApi.getByUserKey()
          .always(function (gotomeet) {
              gotomeetMeetingId = gotomeet.meetingId || '';
          })
          .then(function () {
              meetingsApi.forOrganizerFormatted()
              .then(function (meetings) {
                  // Check if there is at least one upcoming meeting - excluding the G2MM recurring meeting.
                  var now = moment();
                  var hasUpcomingMeeting = meetings.some(function (meeting) {
                      if (meeting.scheduledEndTime) {
                          // We add one hour to the end time, just in case people stay in late.
                          if (moment(meeting.scheduledEndTime).add(1, 'hours') > now) {
                              return true;
                          }
                      } else {
                          // Excluding G2MM's recurring meeting while checking for the count of upcoming meetings.
                          if (gotomeetMeetingId !== meeting.meetingId) {
                              return true;
                          }
                      }
                      return false;
                  });

                  // Criteria:
                  // At least 5 total meetings (including recurring G2MM)
                  // At least 1 upcoming meeting (excluding recurring G2MM)
                  if (meetings.length >= 5 && hasUpcomingMeeting &&
                    (bowser.chrome || bowser.firefox || bowser.msie || bowser.safari)) {
                      userApi.me().then(function (me) {
                          if (me) {
                              // check settings API to see if have `showPlugin` property
                              userApi.settings().then(function (settings) {
                                  if (!settings.hasOwnProperty('showPlugin') || settings.showPlugin !== false) {
                                      dialog.show(new Plugins());
                                  }
                              });
                          }
                      });
                  }
              });
          });
    };

    module.exports = {
        greeting: greeting,
        rememberUser: rememberUser,
        pluginModal: pluginModal
    };
});

